module.exports = __webpack_public_path__ + "images/21fa6b7a612f0ccd0ac2dffc262672183a4b6d38dce6c3fa774deeabac6514c8.svg";